'use strict'

export const findRelativeAncestor = el => {
  let e = el
  do {
    e = e.parentElement
    let style = window.getComputedStyle(e, null)
    if (style.position === 'relative') {
      return e
    }
  } while (e !== null)
}

export const calculateCoordsRelativeToViewport = (
  el,
  position = 'side',
  directionality
) => {
  let rect = el.getBoundingClientRect()
  let ancestor = findRelativeAncestor(el)

  let w = window.innerWidth
  let h = window.innerHeight
  let coords = {}
  if (rect.top > h / 2) {
    // bottom half of viewport, bottom of menu should align to bottom of el
    coords.bottom = ancestor.offsetHeight - (el.offsetTop + el.offsetHeight)
  } else {
    // top half of viewport, top of menu should align to top of el
    coords.top = el.offsetTop
  }
  if (directionality === 'ltr') {
    if (rect.left > w / 2) {
      // right side of viewport, right side of menu should align with left side of el
      coords.right = ancestor.offsetWidth - el.offsetLeft
    } else {
      // left side of viewport, left side of menu should align with right side of el
      coords.left = el.offsetLeft + el.offsetWidth
    }
  } else {
    if (rect.left < w / 2) {
      // left side of viewport, left side of menu should align with right side of el
      coords.left = el.offsetLeft + el.offsetWidth
    } else {
      // right side of viewport, right side of menu should align with left side of el
      coords.right = el.offsetLeft
    }
  }

  return coords
}

export const calculateCoordsRelativeToAncestor = (el, position = 'side') => {
  let ancestor = findRelativeAncestor(el)
  let w = ancestor.offsetWidth
  let h = ancestor.offsetHeight
  let x = el.offsetLeft
  let y = el.offsetTop
  let coords = {}
  if (position === 'side') {
    if (y > h / 2) {
      coords.bottom = h - y
    } else {
      coords.top = y
    }
    if (x > w / 2) {
      coords.right = w - x
    } else {
      coords.left = x
    }
  } else {
    let eh = el.offsetHeight
    let ew = el.offsetWidth
    if (y > h / 2) {
      coords.bottom = y - 8
    } else {
      coords.top = y + eh + 8
    }
    if (x > w / 2) {
      coords.right = Math.max(w - (x + ew), 8)
    } else {
      coords.left = x + 8
    }
  }
  return coords
}
